import type { KeyboardNavigation } from '@app/services/KeyboardNavigation'

import { createThunk } from '@app/store/thunk'

export function getKeyboardNavigation() {
  return createThunk((_dispatch, _getState, context) => context.lookup<KeyboardNavigation>(KeyboardNavigationSymbol))
}
export function setKeyboardNavigation(value: KeyboardNavigation) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(KeyboardNavigationSymbol, value))
}

const KeyboardNavigationSymbol = Symbol('KeyboardNavigation')
